const PHONE_NUMBER_REGEX = /^\+?\d+\d$/;
const PERSONAL_NUMBER_REGEX = /^(?:\d{2})?(\d{6})([+-]?)\d{4}$/;
const ORGANIZATION_OR_PERSONAL_NUMBER_REGEX = /^(\d{6}|\d{8})([-+|\s]?\d{4})?$/;
const FRESHDESK_TICKET_ID_REGEX = /^\d{4,6}$/;
const CRM_ARENDE_NUMBER_REGEX = /^\d{2}-\d{7}$/;

export function isValidPhoneNumber(value: string): boolean {
  return PHONE_NUMBER_REGEX.test(value)
    && value.length >= 5
    && value.length <= 30;
}

export const isPersonalNumber = (personnummer: string) => {
  return PERSONAL_NUMBER_REGEX.test(personnummer);
};

export function isOrganizationOrPersonalNumber(query: string): boolean {
  return ORGANIZATION_OR_PERSONAL_NUMBER_REGEX.test(query);
}

export function isFreshdeskTicketId(query: string): boolean {
  return FRESHDESK_TICKET_ID_REGEX.test(query);
}

export function isCrmArendeNumber(query: string): boolean {
  return CRM_ARENDE_NUMBER_REGEX.test(query);
}

export function isValidSearchTerm(query: string): boolean {
  return (
    isFreshdeskTicketId(query) ||
    isCrmArendeNumber(query) ||
    isOrganizationOrPersonalNumber(query)
  );
}
